import AddBehaviorOccurrence from 'components/Programs/Modals/AddBehaviorOccurrence';
import { useBehaviorTrackingFeature } from 'src/composables/analytics/useBehaviorTrackingFeature';
import { PROGRAM_CLIENT_TYPES, PROGRAM_TYPE_SKILL_ACQUISITION } from 'src/constants/programs';
import { openComponentDialog } from 'src/design-system';
import { computed, inject, unref } from 'vue';

/**
 * Records behavior occurrences against the Skill Acquisition target being run, for every target
 * data type. Call from `setup(props)` of a component taking the DataCollection mixin's props.
 *
 * @param {{ sessionProgram: Object, target: Object }} props
 */
// eslint-disable-next-line import/prefer-default-export
export function useBehaviorOccurrenceRecorder(props) {
  // Provided by CollectData, several components up and at any nesting depth of targets.
  const recordBehaviorOccurrences = inject('recordBehaviorOccurrences', null);
  const { behaviorTrackingEnabled } = useBehaviorTrackingFeature();

  // Supervising and previewing provide no recorder, so the button would otherwise do nothing there.
  const showAddBehavior = computed(() => {
    const program = props.sessionProgram?.program;

    return Boolean(unref(behaviorTrackingEnabled))
      && recordBehaviorOccurrences !== null
      && program?.type === PROGRAM_TYPE_SKILL_ACQUISITION
      && program?.clientType !== PROGRAM_CLIENT_TYPES.STAFF;
  });

  const recordOccurrences = (occurrences = []) => {
    if (!showAddBehavior.value || occurrences.length === 0) {
      return;
    }

    recordBehaviorOccurrences({
      occurrences,
      attachedToTarget: props.target.id,
      skillProgramId: props.sessionProgram.program?.id ?? null,
    });
  };

  const onAddBehaviorOccurrence = () => {
    openComponentDialog(
      AddBehaviorOccurrence,
      { targetLabel: props.target?.label ?? '' },
      ({ occurrences }) => recordOccurrences(occurrences),
    );
  };

  return { showAddBehavior, recordOccurrences, onAddBehaviorOccurrence };
}
